export default __webpack_public_path__ + "static/media/expand_more_blue.ab674c6f.svg";